import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { usersApi } from '../api/users.api'
import { usersKeys } from './query-keys'

export type { AuditEvent, IdmRequestRecord } from '../api/users.api'

export const useIdmRequests = (status?: string) =>
	useQuery({
		queryKey: usersKeys.idmRequests.list(status),
		queryFn: () => usersApi.listIdmRequests(status),
	})

export const useIdmRequest = (requestId: string) =>
	useQuery({
		queryKey: usersKeys.idmRequests.detail(requestId),
		queryFn: () => usersApi.getIdmRequest(requestId),
		enabled: !!requestId,
	})

export const useConfirmIdmRequest = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: usersApi.confirmIdmRequest,
		onSuccess: () => void qc.invalidateQueries({ queryKey: usersKeys.idmRequests.all }),
	})
}

export const useIdmAuditTrail = (requestId: string) =>
	useQuery({
		queryKey: usersKeys.idmRequests.audit(requestId),
		queryFn: () => usersApi.getIdmAuditTrail(requestId),
		enabled: !!requestId,
	})

export const useCancelIdmRequest = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: usersApi.cancelIdmRequest,
		onSuccess: () => void qc.invalidateQueries({ queryKey: usersKeys.idmRequests.all }),
	})
}
